var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",attrs:{"id":"app"}},[(!_vm.$route.meta.hideHeader)?_c('Navbar'):_vm._e(),_c('router-view'),(!_vm.$route.meta.hideFooter && _vm.footerActive)?_c('Footer'):_vm._e(),_c('Login'),_c('Register'),(!_vm.$route.meta.hideFlexibleBall)?_c('FlexibleBall',{attrs:{"this_":_vm.this_}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }